import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useauth';

const Logout = () => {
  const { logout, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await logout();
        navigate('/login');
      } catch (error) {
        console.error('Error logging out:', error);
        navigate('/login');
      }
    };

    handleLogout();
  }, [logout, navigate]);

  return (
    <div>
      <h1>Logging out...</h1>
      {error && <p>Error: {error}</p>}
      <p>Please wait while we log you out of your account.</p>
    </div>
  );
};

export default Logout;